// /apps/patient/src/pages/progress/components/ProgressStatsCards.tsx
import { Activity, Clock, Flame, Calendar } from 'lucide-react';

export interface ProgressSummary {
  total_sessions: number;
  total_exercises: number;
  total_minutes: number;
  current_streak: number;
  sessions_this_week: number;
  last_session_date: string | null;
}

interface ProgressStatsCardsProps {
  summary: ProgressSummary | null;
  loading?: boolean;
}

export function ProgressStatsCards({ summary, loading }: ProgressStatsCardsProps) {
  const stats = [
    {
      label: 'Total Sessions',
      value: summary?.total_sessions ?? 0,
      icon: Calendar,
      color: 'bg-blue-500',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Total Exercises',
      value: summary?.total_exercises ?? 0,
      icon: Activity,
      color: 'bg-green-500',
      bgColor: 'bg-green-50'
    },
    {
      label: 'Current Streak',
      value: summary?.current_streak ?? 0,
      suffix: summary?.current_streak === 1 ? 'day' : 'days',
      icon: Flame,
      color: 'bg-orange-500',
      bgColor: 'bg-orange-50'
    },
    {
      label: 'Total Time',
      value: summary?.total_minutes ?? 0,
      suffix: 'min',
      icon: Clock,
      color: 'bg-purple-500',
      bgColor: 'bg-purple-50'
    }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-lg p-4 shadow-sm animate-pulse">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-200 rounded-lg" />
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-20 mb-2" />
                <div className="h-6 bg-gray-200 rounded w-16" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <div key={stat.label} className="bg-white rounded-lg p-4 shadow-sm">
          <div className="flex items-center space-x-3">
            <div className={`p-2 ${stat.bgColor} rounded-lg`}>
              <stat.icon className={`h-5 w-5 ${stat.color.replace('bg-', 'text-')}`} />
            </div>
            <div>
              <p className="text-sm text-gray-600">{stat.label}</p>
              <p className="text-xl font-semibold text-gray-900">
                {stat.value}
                {stat.suffix && <span className="text-sm font-normal text-gray-500 ml-1">{stat.suffix}</span>}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
